import { MatchCohort } from '../../../types/firestore/Game/Tournament/Cohort';

export function isMatchComplete(match: Pick<MatchCohort, 'stage'>) {
  const { stage } = match;
  return stage === 'complete';
}
